// extracted by mini-css-extract-plugin
export default {"header":"ZbRI9","fixed":"V_a4b","topline":"U9Yvr","compensation":"jfVlj","animable":"KpL5X","pinned":"lJQE5"};